// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen` from
// x-flags.doRenderReactQueryQueryHook on POST /pool/create-options.

import { useQuery, type UseQueryOptions } from "@tanstack/react-query";
import type {
  typePoolCreateOptionsBody,
  typePoolCreateOptionsOutput200,
} from "../../sdk/pool/postPoolCreateOptions";
import useCallSdk from "../../sdk-helpers/useCallSdk";

export function buildPoolCreateOptionsQueryKey(
  payload: typePoolCreateOptionsBody,
): string[] {
  const queryKeySegments: string[] = [];

  return ["post:pool:poolCreateOptions", "svc:pool-api", ...queryKeySegments];
}

type QueryOptions = Partial<
  UseQueryOptions<
    typePoolCreateOptionsOutput200,
    unknown,
    typePoolCreateOptionsOutput200,
    string[]
  >
> & {
  // Isolates two callers that query the same data for independent UI state
  // (e.g. a dropdown search vs a table both listing the same resource).
  queryKeyIdentifier?: string;
};

export default function usePoolCreateOptions(
  payload: typePoolCreateOptionsBody,
  options?: QueryOptions,
) {
  // No staleTime default here on purpose. Freshness is the consuming app's
  // decision and belongs in its QueryClient, in one place: a default set on the
  // hook would silently beat it for every screen. Pass one per call to override.
  const resolvedOptions = options ?? {};

  let queryKey = buildPoolCreateOptionsQueryKey(payload);
  if (resolvedOptions.queryKeyIdentifier) {
    queryKey = [...queryKey, resolvedOptions.queryKeyIdentifier];
  }

  const { callSdk } = useCallSdk();
  return useQuery({
    queryKey,
    queryFn: () => callSdk().postPoolCreateOptions(payload),
    ...resolvedOptions,
  });
}
